// ============================================================================
// Constants
// ============================================================================
export const MAX_SIZE_MB = 5;
export const ACCEPT_MIME = ['image/jpeg', 'image/png', 'application/pdf'] as const;
export const ACCEPT_EXTENSIONS = '.jpg,.jpeg,.png,.pdf';
export const FILE_NAME_MAX_LENGTH = 40;
export const FILE_NAME_PREFIX_LENGTH = 24;
export const FILE_NAME_SUFFIX_LENGTH = 12;
